import JoditEditor from 'jodit-react';

interface EditorProps {
    value: string;
    onChange: (value: string) => void;
}

export const Editor = ({ value, onChange }: EditorProps) => {
    return (
        <JoditEditor
            value={value}
            config={{
                readonly: false,
                height: 500,
                language: 'fa',
                toolbarAdaptive: false,
                uploader: {
                    insertImageAsBase64URI: true,
                },
                placeholder: 'محتوا را وارد کنید...',
                buttons: [
                    'source',
                    'preview',
                    'find',
                    'selectall',
                    '|',
                    'cut',
                    'copy',
                    'paste',
                    '|',
                    'undo',
                    'redo',
                    '|',
                    'bold',
                    'italic',
                    'underline',
                    'strikethrough',
                    '|',
                    'superscript',
                    'subscript',
                    '|',
                    'ul',
                    'ol',
                    'outdent',
                    'indent',
                    '|',
                    'font',
                    'fontsize',
                    'brush',
                    'paragraph',
                    '|',
                    'image',
                    'file',
                    'video',
                    'table',
                    'link',
                    '|',
                    'align',
                    'hr',
                    '|',
                    'print',
                    'fullsize',
                    'about',
                ],
                showCharsCounter: true,
                showWordsCounter: true,
                showXPathInStatusbar: true,
                enableDragAndDropFileToEditor: true,
                spellcheck: true,
                askBeforePasteHTML: false,
                askBeforePasteFromWord: false,
                disablePlugins: [],
            }}
            onBlur={(newContent) => onChange(newContent)}
        />
    );
};
